import React, { Fragment } from 'react'

import { Line } from 'rc-progress'

import {
  string, number, bool, func,
} from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

import Icon from '../../Icon/Icon'

function FilePreview({
  fileName,
  iconName,
  imgUrl,
  progress = 100,
  isProcessing = false,
  onImageClick = NOOP,
  index = 0,
  fileUrl = '',
  download = false,
  imageAltText = null,
}) {
  const attachmentClassName = (progress === 100) ? 'attachment' : 'attachment is-uploading'

  function handleImageClick() {
    if (!onImageClick) { return }
    onImageClick(index)
  }

  const preview = (
    <div className="attachment-preview">
      {progress === 100 && imgUrl ? (
        <img
          className={`attachment-preview__img ${onImageClick ? 'is-clickable' : ''}`}
          src={imgUrl}
          onClick={handleImageClick}
          alt={imageAltText}
        />
      ) : (
        <span className="attachment-preview__icon">
          <Icon type={['fal', iconName]} notSpaced />
        </span>
      )}
    </div>
  )

  return (
    <div className={attachmentClassName}>
      {(progress < 100 || isProcessing) && (
        <Fragment>
          <div className="attachment-progress">
            <Line percent={progress} strokeWidth="2" trailWidth="2" strokeColor="#31a28d" />
          </div>
          {isProcessing && (
            <div className="processing-text">Processing...</div>
          )}
        </Fragment>
      )}
      {download && fileUrl ? (
        <a href={fileUrl} download={fileName}>
          {preview}
        </a>
      ) : (
        preview
      )}
    </div>
  )
}

FilePreview.propTypes = {
  fileName: string.isRequired,
  iconName: string.isRequired,
  imgUrl: string,
  progress: number,
  isProcessing: bool,
  onImageClick: func,
  index: number,
  fileUrl: string,
  download: bool,
  imageAltText: string,
}

export default FilePreview
